import script from "./PatientAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientAvatar.vue?vue&type=script&setup=true&lang=js"

import "./PatientAvatar.vue?vue&type=style&index=0&id=fe75cf76&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe75cf76"]])

export default __exports__